<template>
  <div class="plan">
    <div class="plan-contents">
      <h1>PLAN</h1>
      <p class="title">本気で食事改善するなら年間PLANがお得</p>
      <table>
        <tbody>
          <tr>
            <td class="key">年間PLAN</td>
            <td class="value">¥ 1500/年(税抜)<br><span>¥ 125/月(税込)</span></td>
          </tr>
        </tbody>
      </table>
      <button v-on:click="annualPay()">年間PLANに登録</button>
      <table>
        <tbody>
          <tr>
            <td class="key">月額PLAN</td>
            <td class="value">¥ 180/月(税込)<br></td>
          </tr>
        </tbody>
      </table>
      <button v-on:click="monthlyPay()">月額PLANに登録</button>
    </div>
    <div class="image-contents">
      <p class="title">PLAN内容</p>
      <div class="price-inner">
        <p class="sub-title">毎日３食分の献立</p>
        <p>〜毎日配信〜</p>
        <p>＋</p>
        <p class="sub-title">買い物リスト</p>
        <p>〜3日毎に配信〜</p>
        <p>＋</p>
        <p class="sub-title">オリジナル外食カロリー表</p>
        <p>〜定期的に更新〜</p>
        <p class="price">¥ 180/月(税抜)</p>
      </div>
    </div>
  </div>
  </div>
</template>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
button {
  color: #42b983;
}
.item {
  padding: 15px;
  margin: 5px;
  text-align: center;
}
.plan-contents table{
  width: 40%;
  margin:24px auto;
  margin-top: 5%;
  border: 2px inset black;
}
.plan-contents tr{
  height: 80px;
}
img {
  max-width: 100%;
  height: auto;
}
p {
  text-align: left;
}
.plan-contents{
  padding-bottom: 5%;
}
.plan-contents .title{
  font-size: 24px;
  color: orange;
  text-align: center;
}
.plan-contents .key{
  width: 30%;
  background:black;
  color: white;
}
.plan-contents table{
  border-spacing: 0px;
}
.plan-contents .value{
  font-size: 24px;
  font-weight: bold;
}
.plan-contents span{
  font-size: 12px;
  font-weight: normal;
  font-family: Hiragino Kaku Gothic Pro;
}
.plan-contents button{
  background: orange;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  border: 0px;
  font-size: 18px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.image-contents p{
  margin-top: 0px;
}
.image-contents {
  position: relative;
  height: auto;
  padding-top: 5%;
  padding-bottom: 5%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../assets/bg-transparent.jpg");
}
.image-contents .title{
  font-size: 32px;
  text-align: center;
}
.image-contents .price-inner{
  padding:5%;
  background:rgba(255,255,255);
  border: 3px inset black;
  width: 20%;
  margin:5% auto;
}
.image-contents .sub-title{
  font-size:24px;
}
.image-contents .price-inner p{
  text-align: center;
}
.image-contents .price{
  color: red;
  font-size:24px;
}
@media ( max-width : 600px ){
.image-contents .price-inner {
    padding: 5%;
    background: rgba(255,255,255);
    border: 3px inset black;
    width: 60%;
    margin: 10% auto;
}
.plan-contents table{
  width: 80%;
  margin-top: 10%;
}
.plan-contents button{
  background: orange;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 14px;
  border: 0px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.plan-contents{
  padding-bottom: 20%;
}
}
</style>

<script>
export default {
  name: 'Plan',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    annualPay: function () {
      if (!localStorage.userId) {
        location.href = '/charge?plan=0'
      } else {
        alert('既に購入済みです、マイページから課金プランの変更、削除ができます！')
      }
    },
    monthlyPay: function () {
      if (!localStorage.userId) {
        location.href = '/charge?plan=1'
      } else {
        alert('既に購入済みです、マイページから課金プランの変更、削除ができます！')
      }
    }
  },
  created: function () {
    // Planを取得
    let self = this
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    /*
    this.userId = result['userId']
    if (!this.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    } else {
      //this.getUserInformation()
    }*/
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plan/Plan.vue